var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00882 5.34108V8.2188C8.00882 8.55917 7.73288 8.83475 7.39287 8.83475H1.78087C1.44049 8.83475 1.16492 8.55881 1.16492 8.2188V2.60716C1.16492 2.26679 1.44086 1.99121 1.78087 1.99121H4.65858C4.98076 1.99121 5.24177 1.7302 5.24177 1.40803C5.24177 1.08694 4.98148 0.826294 4.66004 0.826294H1.49255C0.668372 0.826294 0 1.49467 0 2.31885L0 8.50748C0 9.33166 0.668372 10 1.49255 10H7.68118C8.50536 10 9.17374 9.33166 9.17374 8.50748V5.33963C9.17374 5.01855 8.91345 4.7579 8.592 4.7579C8.26983 4.7579 8.00882 5.01891 8.00882 5.34108Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21121 6.61228L9.82904 0.994458C10.0566 0.766935 10.0566 0.398166 9.82904 0.170642C9.60151 -0.0568808 9.23274 -0.0568808 9.00522 0.170642L3.3874 5.78883C3.31641 5.85982 3.27637 5.95665 3.27637 6.05712V6.34435C3.27637 6.55403 3.44637 6.72368 3.65569 6.72368H3.94292C4.04339 6.72368 4.13986 6.68363 4.21121 6.61264V6.61228Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyIcon);
export default __webpack_public_path__ + "static/media/ModifyIcon.4141c084df5df88858eb9b99dad19728.svg";
export { ForwardRef as ReactComponent };